export default __webpack_public_path__ + "static/media/0xcfb54a6d2da14abecd231174fc5735b4436965d8.d731cbf5.webp";